import { IPagamentoRepository } from '../repositories/IPagamentoRepository'
import IUseNewHomeResponseDTO from '../entities/IUseNewHomeResponseDTO'

export interface IValidateUseNewHome {
  execute(): Promise<IUseNewHomeResponseDTO>
}

export default class ValidateUseNewHomeImpl implements IValidateUseNewHome {
  constructor(private readonly pagamentosRepository: IPagamentoRepository) {}
  async execute(): Promise<IUseNewHomeResponseDTO> {
    return this.pagamentosRepository.validarUsarNovaHome()
  }
}
